/** @format */

import { Component, Input, OnChanges, OnInit, SimpleChanges, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { State } from 'src/app/store';
import { LoadStaticData, User } from 'src/app/store/application';
import { Profile } from 'src/app/models/profile';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
	@Input() profileImg: Blob | string | null = null;
	@Input() profile!: Profile;
	@Input() isLoadingData: boolean = false;

	isTestEnv: boolean = false;

	base64ProfilePhoto: any;
	// isDelegatedAsManager: boolean = false;
	// isFutureDelegatedManager: boolean = false;

	private readonly _destroying$ = new Subject<void>();

	role: any = [];

	constructor(
		public router: Router,
		private store$: Store<State>,
		private msalBroadcastService: MsalBroadcastService,
		private changeDetectorRef: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		// Based on https://learn.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-angular-auth-code#conditional-rendering
		this.msalBroadcastService.inProgress$
			.pipe(
				filter((status: InteractionStatus) => status === InteractionStatus.None),
				takeUntil(this._destroying$)
			)
			.subscribe(() => {
				this.store$.dispatch(LoadStaticData());
			});

		this.getRoleFromLocalStorage();
		this.isTestEnv = window.location.href.includes('https://tsuat.dnv.org/');
		// console.log('role: ', this.role);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if ('string' === typeof this.profileImg) {
			this.base64ProfilePhoto = this.profileImg;
			this.getRoleFromLocalStorage();
		} else if (this.profileImg) {
			let reader = new FileReader();
			reader.onloadend = () => {
				this.base64ProfilePhoto = reader.result;
			};
			reader.readAsDataURL(this.profileImg);
			this.getRoleFromLocalStorage();
		}

		if (
			changes.profile &&
			changes.profile.currentValue &&
			changes.profile.previousValue &&
			changes.profile.currentValue.user.id !== changes.profile.previousValue.user.id
		) {
			this.role = [];
			this.getRoleFromLocalStorage();
			this.changeDetectorRef.detectChanges();
		}
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}

	getRoleFromLocalStorage(): void {
		[localStorage].forEach((storage: Storage) => {
			for (let i = 0, len = storage.length; i < len; ++i) {
				const key = storage.key(i);

				if (key && !key.match('refreshtoken') && !key.match('accesstoken') && key.match('login.windows.net')) {
					const data = JSON.parse(storage.getItem(key)!);
					if (data.authorityType && data.authorityType === 'MSSTS') {
						if (
							data.idTokenClaims &&
							data.idTokenClaims.roles &&
							data.idTokenClaims.preferred_username.toLowerCase() === this.profile.user.upn.toLowerCase()
						) {
							this.role.push(...data.idTokenClaims.roles);
						}
					}
				}
			}
		});
	}

	isManagerOrTimeKeeper(): boolean {
		return this.isManager() || this.isTimeKeeper();
	}

	isAdmin(): boolean {
		let result = false;
		this.role?.forEach((r: string) => {
			if (r.toLowerCase() === 'admin') {
				result = true;
			}
		});

		return result;
	}

	isManager(): boolean {
		let result = false;
		this.role?.forEach((r: string) => {
			if (r.toLowerCase() === 'manager') {
				result = true;
			}
		});

		return result;
		// return true;
	}

	isTimeKeeper(): boolean {
		let result = false;
		this.role?.forEach((r: string) => {
			if (r.toLowerCase() === 'timekeepers') {
				result = true;
			}
		});

		return result;
		// return true;
	}

	isCurrentActiveRoute(routePath: string) {
		if (routePath.toLowerCase().indexOf('team') > -1 || routePath.toLowerCase().indexOf('profiles')) {
			return this.router.url === routePath;
		}
		// for when other params appended to route
		return this.router.url.indexOf(routePath) > -1;
	}
}
